import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';
import { UtilService } from '../../_services/util.service';

class ProductRuntime implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;

    constructor(private utilService: UtilService) {}

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        elem: JQuery,
        attrs: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpProductRuntime'] = (
            modelValue: DateInterval
        ): boolean => {
            const periodType: PeriodType = scope.$eval(attrs.pkpProductRuntime);
            if (periodType == null) return true;

            const start: moment.Moment = moment(modelValue.start);
            const end: moment.Moment = moment(modelValue.end);

            return this.utilService.validateProductRuntime(
                periodType,
                start,
                end
            );
        };

        attrs.$observe('pkpProductRuntime', () => ngModelCtrl.$validate());
    };
}

ProductRuntime.$inject = ['utilService'];

angular
    .module('app')
    .directive(
        'pkpProductRuntime',
        (utilService) => new ProductRuntime(utilService)
    );
